import { UniverseType } from 'src_common/common/universe';
import { features as akbets } from 'src/domains/common/universes/akbets/akbets.features';
import { features as bresbet } from 'src/domains/common/universes/bresbet/bresbet.features';
import { features as energy } from 'src/domains/common/universes/energy/energy.features';
import { features as gentlemanjim } from 'src/domains/common/universes/gentlemanjim/gentlemanjim.features';
import { features as mcbookie } from 'src/domains/common/universes/mcbookie/mcbookie.features';
import { features as planetsportbet } from 'src/domains/common/universes/planetsportbet/planetsportbet.features';
import { features as star } from 'src/domains/common/universes/star/star.features';
import { features as dragonbet } from 'src/domains/common/universes/dragonbet/dragonbet.features';
import { features as bestodds } from 'src/domains/common/universes/bestodds/bestodds.features';
import { features as pricedup } from 'src/domains/common/universes/pricedup/pricedup.features';
import { features as betwright } from 'src/domains/common/universes/betwright/betwright.features';
import { features as londonbet } from 'src/domains/common/universes/londonbet/londonbet.features';
import { features as betstgeorge } from 'src/domains/common/universes/betstgeorge/betstgeorge.features';
import { features as properbet } from 'src/domains/common/universes/properbet/properbet.features';

import { featuresDev } from './universesFeatureDev';
import { ConfigTypes } from 'src/AppState/ConfigState/types';

const imports: Record<UniverseType, ConfigTypes> = {
    akbets,
    bresbet,
    dragonbet,
    energy,
    londonbet,
    mcbookie,
    planetsportbet,
    star,
    gentlemanjim,
    pricedup,
    betwright,
    bestodds,
    betstgeorge,
    properbet,
};

export const getFeatures = (universe: UniverseType, isProdMode: boolean): ConfigTypes => {
    const features = imports[universe];

    if (isProdMode === true) {
        return features;
    }

    const featuresDevUniverse = featuresDev[universe];

    return {
        ...features,
        ...featuresDevUniverse,
    };
};
